

<app-loading-list [isLoading]="isLoading" [totalRegistros]="totalRegistros"></app-loading-list>

<app-pagination-table [isLoading]="isLoading" [registros]="registros" [totalRegistros]="totalRegistros" [pagina]="pagina" (pageChangeTableEvent)="pageChangeLoadingPagination($event)"></app-pagination-table>
